module.exports = __webpack_public_path__ + "static/media/(H)_MG_6324_-_Joias_Contenporaneas.c6099d6a.jpg";